var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('v-btn',{staticClass:"pa-0 ma-0",attrs:{"icon":"","flat":"","small":"","color":"secondary"},on:{"click":() => {}}},[_c('v-icon',[_vm._v("arrow_left")])],1)],1),_c('v-flex',{attrs:{"shrink":""}},[_vm._v(" Hello2 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }